import {
  utils,
} from '@ama-sdk/core';
import {
  AlternativeOfferConfirmationJob,
} from '@dapi/sdk';
import {
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  alternativeOfferCphOsl1,
  alternativeOfferCphOsl2,
  alternativeOfferForUnOnly1,
  alternativeOfferForUnOnly2,
  alternativeOfferForUnOnly3,
  alternativeOfferForUnOnly4,
  alternativeOfferForUnOnly5,
  alternativeOfferHelTku1,
  alternativeOfferHelTku2,
  alternativeOfferHelTku3,
  alternativeOfferOslCph1,
  alternativeOfferOslCph2,
  alternativeOfferOslLhr1,
  alternativeOfferOslLhr2,
  alternativeOfferTkuHel1,
  alternativeOfferTkuHel2,
  alternativeOfferTkuHel3,
  FLIGHT1,
  FLIGHT10,
  FLIGHT2,
  FLIGHT3,
  FLIGHT4,
  FLIGHT5,
  FLIGHT6,
  FLIGHT7,
  FLIGHT8,
  FLIGHT9,
  inboundAlternativeOfferHelTku1,
  inboundAlternativeOfferHelTku10,
  inboundAlternativeOfferHelTku11,
  inboundAlternativeOfferHelTku12,
  inboundAlternativeOfferHelTku13,
  inboundAlternativeOfferHelTku14,
  inboundAlternativeOfferHelTku15,
  inboundAlternativeOfferHelTku16,
  inboundAlternativeOfferHelTku17,
  inboundAlternativeOfferHelTku18,
  inboundAlternativeOfferHelTku19,
  inboundAlternativeOfferHelTku2,
  inboundAlternativeOfferHelTku20,
  inboundAlternativeOfferHelTku3,
  inboundAlternativeOfferHelTku4,
  inboundAlternativeOfferHelTku5,
  inboundAlternativeOfferHelTku6,
  inboundAlternativeOfferHelTku7,
  inboundAlternativeOfferHelTku8,
  inboundAlternativeOfferHelTku9,
} from '../dictionaries/index';

export const getAlternativeOffersCheckin = {
  data: [
    {
      type: 'alternative-offers',
      id: '1DwpnpTjKNI',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 4500,
          flights: [
            {
              id: 'FLT1',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1DxpnpTS-_Q',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 4500,
          flights: [
            {
              id: 'FLT2',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1DypnpTrIhF',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 4500,
          flights: [
            {
              id: 'FLT3',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1DzpnpTSoPQ',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 4800,
          flights: [
            {
              id: 'FLT4',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D0pnpTqSl',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 12_600,
          flights: [
            {
              id: 'FLT5',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT6',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D1pnpTmNj-A',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 13_800,
          flights: [
            {
              id: 'FLT7',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT8',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D2pnpTk7Jt',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 17_700,
          flights: [
            {
              id: 'FLT9',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT10',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D3pnpT-DvB',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 14_100,
          flights: [
            {
              id: 'FLT9',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT11',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D4pnpT4FGj',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 15_000,
          flights: [
            {
              id: 'FLT12',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT13',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D5pnpT0LNb',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 15_300,
          flights: [
            {
              id: 'FLT14',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT6',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D6pnpT3ODj',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 15_900,
          flights: [
            {
              id: 'FLT15',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT16',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D7pnpTKCiE',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 16_500,
          flights: [
            {
              id: 'FLT17',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT8',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D8pnpTB1Sj',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 16_800,
          flights: [
            {
              id: 'FLT18',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT6',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D9pnpTdGhd',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 18_300,
          flights: [
            {
              id: 'FLT19',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT6',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D-pnpTMCVa',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 18_300,
          flights: [
            {
              id: 'FLT20',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT16',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1D_pnpTZ07c',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 19_500,
          flights: [
            {
              id: 'FLT21',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT6',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1EApnpTcI33',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 20_700,
          flights: [
            {
              id: 'FLT22',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT8',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1EBpnpTU0Ly',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 22_800,
          flights: [
            {
              id: 'FLT15',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT13',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1ECpnpTBYcm',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 23_100,
          flights: [
            {
              id: 'FLT23',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT16',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1EDpnpTMjze',
      expiryDateTime: new utils.DateTime(todayPlusNdays('07:23', 15)),
      air: {
        bound: {
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          duration: 23_400,
          flights: [
            {
              id: 'FLT5',
              bookingClass: 'Y',
              cabin: 'eco'
            },
            {
              id: 'FLT16',
              bookingClass: 'Y',
              cabin: 'eco'
            }
          ]
        }
      }
    }
  ],
  dictionaries: {
    airline: {
      AF: 'AIR FRANCE',
      KL: 'KLM ROYAL DUTCH AIRLINES'
    },
    location: {
      AMS: {
        type: 'airport',
        airportName: 'SCHIPHOL AIRPORT',
        cityCode: 'AMS',
        cityName: 'AMSTERDAM',
        countryCode: 'NL'
      },
      CDG: {
        type: 'airport',
        airportName: 'CHARLES DE GAULLE',
        cityCode: 'PAR',
        countryCode: 'FR'
      },
      ZRH: {
        type: 'airport',
        airportName: 'ZURICH AIRPORT',
        cityCode: 'ZRH',
        cityName: 'ZURICH',
        countryCode: 'CH'
      },
      PAR: {
        type: 'city',
        cityCode: 'PAR',
        cityName: 'PARIS',
        countryCode: 'FR'
      }
    },
    flight: {
      FLT22: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('16:40', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('17:55', 0))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1140',
        duration: 4500,
        aircraftCode: '318'
      },
      FLT8: {
        departure: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('21:00', 0))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('22:25', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1969',
        duration: 5100,
        aircraftCode: 'E90'
      },
      FLT20: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('11:40', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('13:05', 0))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1640',
        duration: 5100,
        aircraftCode: '319'
      },
      FLT12: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('14:30', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('15:45', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1234',
        duration: 4500,
        aircraftCode: '73H'
      },
      FLT13: {
        departure: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('17:20', 0))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('18:40', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1963',
        duration: 4800,
        aircraftCode: '73W'
      },
      FLT3: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('16:40', 1)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('17:55', 1))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1814',
        duration: 4500,
        aircraftCode: '318'
      },
      FLT6: {
        departure: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('12:20', 0))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('13:45', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1959',
        duration: 5100,
        aircraftCode: 'E90'
      },
      FLT4: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('21:20', 1)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('22:40', 1))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        duration: 4800,
        aircraftCode: '318'
      },
      FLT15: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('12:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('13:45', 0))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1740',
        duration: 5100,
        aircraftCode: '318'
      },
      FLT9: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('07:10', 1)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('08:35', 1))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1240',
        duration: 5100,
        aircraftCode: '321'
      },
      FLT21: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('08:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('09:45', 0))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1340',
        duration: 5100,
        aircraftCode: '320'
      },
      FLT5: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('10:15', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('11:35', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1230',
        duration: 4800,
        aircraftCode: '73H'
      },
      FLT11: {
        departure: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('09:40', 1))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('11:05', 1))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1957',
        duration: 5100,
        aircraftCode: '73W'
      },
      FLT16: {
        departure: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('15:15', 0))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('16:45', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1961',
        duration: 5400,
        aircraftCode: '73H'
      },
      FLT2: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('12:55', 2)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('14:10', 2))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1614',
        duration: 4500,
        aircraftCode: '318'
      },
      FLT1: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('07:35', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('08:50', 0))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1114',
        duration: 4500,
        aircraftCode: '320'
      },
      FLT17: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('17:50', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('19:20', 0))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '1440',
        duration: 5400,
        aircraftCode: '319'
      },
      FLT18: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('09:05', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('10:30', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '123',
        duration: 5100,
        aircraftCode: '73W'
      },
      FLT14: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('09:30', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('10:55', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1228',
        duration: 5100,
        aircraftCode: '73W'
      },
      FLT10: {
        departure: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('10:45', 1))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('12:05', 1))
        },
        operatingAirlineCode: 'AF',
        marketingAirlineCode: 'AF',
        marketingFlightNumber: '9999',
        duration: 4800,
        aircraftCode: '772'
      },
      FLT7: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('18:35', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('20:00', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1244',
        duration: 5100,
        aircraftCode: '73H'
      },
      FLT23: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('10:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('11:45', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '55',
        duration: 5100,
        aircraftCode: '73H'
      },
      FLT19: {
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('08:40', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'AMS',
          dateTime: new utils.DateTime(todayPlusNdays('10:00', 0))
        },
        operatingAirlineCode: 'KL',
        marketingAirlineCode: 'KL',
        marketingFlightNumber: '1224',
        duration: 4800,
        aircraftCode: '73H'
      }
    },
    aircraft: {
      318: 'AIRBUS A318',
      319: 'AIRBUS A319',
      320: 'AIRBUS A320',
      321: 'AIRBUS A321',
      772: 'BOEING 777-200/200ER',
      '73H': 'BOEING 737-800 (WINGLETS)',
      '73W': 'BOEING 737-700 (WINGLETS)',
      E90: 'EMBRAER 190'
    }
  }
};

export const getAlternativeOfferConfirmationJobCompletedCheckinFailed = {
  warnings: [
    {
      code: '65016',
      title: 'UNABLE TO REACCEPT TRAVELERS',
      detail: 'Acceptance is closed.'
    }
  ],
  data: {
    id: 'AF57516314',
    status: 'completed',
    reacceptanceStatus: 'completed'
  },
  dictionaries: {
    location: {
      PAR: {
        type: 'city',
        cityCode: 'PAR',
        cityName: 'PARIS',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      ZRH: {
        type: 'airport',
        airportName: 'ZURICH AIRPORT',
        cityCode: 'ZRH',
        cityName: 'ZURICH',
        countryCode: 'CH',
        timeZone: 'UTC+0200'
      },
      CDG: {
        type: 'airport',
        airportName: 'CHARLES DE GAULLE',
        cityCode: 'PAR',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      CH: 'SWITZERLAND',
      FR: 'FRANCE'
    },
    airline: {
      AF: 'AIR FRANCE'
    },
    aircraft: {
      318: 'AIRBUS A318'
    },
    flight: {
      ST1: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('19:20', 1))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('20:40', 1))
        },
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false
      },
      ST3: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        operatingAirlineFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('21:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
        },
        aircraftCode: '318',
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['S']
        },
        flightStatus: 'scheduled'
      }
    },
    tax: {
      IZ: 'IZ',
      O4: 'O4',
      QX: 'QX',
      FR: 'FR'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      ADTK: {
        name: 'REQUEST TO ADD TICKET INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    },
    meal: {
      S: 'SNACK OR BRUNCH'
    }
  },
  included: {
    orders: [
      {
        id: 'R3SVSI',
        creationPointOfSale: {
          pointOfSaleId: 'PARAF0ERS',
          countryCode: 'FR'
        },
        creationDateTime: new utils.DateTime(todayPlusNdays('04:46', 0)),
        lastModificationDateTime: new utils.DateTime(todayPlusNdays('06:25', 0)),
        isGroupBooking: false,
        air: {
          bounds: [
            {
              airBoundId: '1915634eab8',
              originLocationCode: 'CDG',
              destinationLocationCode: 'ZRH',
              flights: [
                {
                  id: 'ST3',
                  cabin: 'eco',
                  bookingClass: 'Y',
                  statusCode: 'HK'
                }
              ],
              duration: 4800,
              disruptionStatus: {
                originalFlights: [
                  {
                    id: 'ST1'
                  }
                ],
                departure: {
                  locationCode: 'CDG',
                  sameAirport: true,
                  sameCity: true,
                  sameDay: false,
                  deltaTime: -86_400
                },
                arrival: {
                  locationCode: 'ZRH',
                  sameAirport: true,
                  sameCity: true,
                  sameDay: false,
                  deltaTime: -86_400
                },
                connection: {
                  status: 'ok',
                  delta: 0,
                  sameViaPoint: true,
                  deltaTime: 0
                },
                duration: 4800
              }
            }
          ]
        },
        services: [
          {
            id: 'OT32',
            descriptions: [
              {
                type: 'shortText',
                content: 'ADTK'
              }
            ],
            quantity: 1,
            statusCode: ' ',
            parameters: [
              {
                code: 'TEXT',
                value: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
              }
            ]
          }
        ],
        travelers: [
          {
            id: 'PT1',
            names: [
              {
                firstName: 'C',
                lastName: 'Srtst',
                nameType: 'universal',
                isPreferred: true
              }
            ]
          }
        ],
        contacts: [
          {
            id: 'OT2',
            category: 'other',
            contactType: 'Phone',
            deviceType: 'landline',
            purpose: 'standard',
            number: 'PAR - AIR FRANCE - A'
          }
        ],
        travelDocuments: [
          {
            flightIds: ['ST3'],
            travelerIds: ['PT1'],
            id: '0571443980305',
            documentType: 'eticket',
            price: {
              base: 79_200,
              total: 82_310,
              currencyCode: 'EUR',
              taxes: [
                {
                  value: 463,
                  currencyCode: 'EUR',
                  code: 'FR'
                },
                {
                  value: 1170,
                  currencyCode: 'EUR',
                  code: 'FR'
                },
                {
                  value: 113,
                  currencyCode: 'EUR',
                  code: 'IZ'
                },
                {
                  value: 150,
                  currencyCode: 'EUR',
                  code: 'O4'
                },
                {
                  value: 1214,
                  currencyCode: 'EUR',
                  code: 'QX'
                }
              ],
              totalTaxes: 3110
            },
            fareInfos: [
              {
                fareClass: 'YS40BENN',
                couponStatus: 'open',
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingFlightNumber: '1414',
                  departure: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('21:20', 0))
                  },
                  arrival: {
                    locationCode: 'ZRH',
                    dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
                  }
                }
              }
            ]
          }
        ],
        specialServiceRequests: [
          {
            id: 'OT32',
            code: 'ADTK',
            airlineCode: '1A',
            statusCode: ' ',
            freetext: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
          }
        ]
      }
    ]
  }
};

export const getAlternativeOfferConfirmationJobCompletedCheckinSucceeded = {
  data: {
    id: 'AF57516314',
    status: 'completed',
    reacceptanceStatus: 'completed'
  },
  dictionaries: {
    location: {
      PAR: {
        type: 'city',
        cityCode: 'PAR',
        cityName: 'PARIS',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      ZRH: {
        type: 'airport',
        airportName: 'ZURICH AIRPORT',
        cityCode: 'ZRH',
        cityName: 'ZURICH',
        countryCode: 'CH',
        timeZone: 'UTC+0200'
      },
      CDG: {
        type: 'airport',
        airportName: 'CHARLES DE GAULLE',
        cityCode: 'PAR',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      CH: 'SWITZERLAND',
      FR: 'FRANCE'
    },
    airline: {
      AF: 'AIR FRANCE'
    },
    aircraft: {
      318: 'AIRBUS A318'
    },
    flight: {
      ST1: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('19:20', 1))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('20:40', 1))
        },
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false
      },
      ST3: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        operatingAirlineFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('21:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
        },
        aircraftCode: '318',
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['S']
        },
        flightStatus: 'scheduled'
      }
    },
    tax: {
      IZ: 'IZ',
      O4: 'O4',
      QX: 'QX',
      FR: 'FR'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      ADTK: {
        name: 'REQUEST TO ADD TICKET INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    },
    meal: {
      S: 'SNACK OR BRUNCH'
    }
  },
  included: {
    orders: [
      {
        id: 'R3SVSI',
        creationPointOfSale: {
          pointOfSaleId: 'PARAF0ERS',
          countryCode: 'FR'
        },
        creationDateTime: new utils.DateTime(todayPlusNdays('04:46', 0)),
        lastModificationDateTime: new utils.DateTime(todayPlusNdays('06:25', 0)),
        isGroupBooking: false,
        air: {
          bounds: [
            {
              airBoundId: '1915634eab8',
              originLocationCode: 'CDG',
              destinationLocationCode: 'ZRH',
              flights: [
                {
                  id: 'ST3',
                  cabin: 'eco',
                  bookingClass: 'Y',
                  statusCode: 'HK'
                }
              ],
              duration: 4800,
              disruptionStatus: {
                originalFlights: [
                  {
                    id: 'ST1'
                  }
                ],
                departure: {
                  locationCode: 'CDG',
                  sameAirport: true,
                  sameCity: true,
                  sameDay: false,
                  deltaTime: -86_400
                },
                arrival: {
                  locationCode: 'ZRH',
                  sameAirport: true,
                  sameCity: true,
                  sameDay: false,
                  deltaTime: -86_400
                },
                connection: {
                  status: 'ok',
                  delta: 0,
                  sameViaPoint: true,
                  deltaTime: 0
                },
                duration: 4800
              }
            }
          ]
        },
        services: [
          {
            id: 'OT32',
            descriptions: [
              {
                type: 'shortText',
                content: 'ADTK'
              }
            ],
            quantity: 1,
            statusCode: ' ',
            parameters: [
              {
                code: 'TEXT',
                value: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
              }
            ]
          }
        ],
        travelers: [
          {
            id: 'PT1',
            names: [
              {
                firstName: 'C',
                lastName: 'Srtst',
                nameType: 'universal',
                isPreferred: true
              }
            ]
          }
        ],
        contacts: [
          {
            id: 'OT2',
            category: 'other',
            contactType: 'Phone',
            deviceType: 'landline',
            purpose: 'standard',
            number: 'PAR - AIR FRANCE - A'
          }
        ],
        travelDocuments: [
          {
            flightIds: ['ST3'],
            travelerIds: ['PT1'],
            id: '0571443980305',
            documentType: 'eticket',
            price: {
              base: 79_200,
              total: 82_310,
              currencyCode: 'EUR',
              taxes: [
                {
                  value: 463,
                  currencyCode: 'EUR',
                  code: 'FR'
                },
                {
                  value: 1170,
                  currencyCode: 'EUR',
                  code: 'FR'
                },
                {
                  value: 113,
                  currencyCode: 'EUR',
                  code: 'IZ'
                },
                {
                  value: 150,
                  currencyCode: 'EUR',
                  code: 'O4'
                },
                {
                  value: 1214,
                  currencyCode: 'EUR',
                  code: 'QX'
                }
              ],
              totalTaxes: 3110
            },
            fareInfos: [
              {
                fareClass: 'YS40BENN',
                couponStatus: 'checkedIn',
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingFlightNumber: '1414',
                  departure: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('21:20', 0))
                  },
                  arrival: {
                    locationCode: 'ZRH',
                    dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
                  }
                }
              }
            ]
          }
        ],
        specialServiceRequests: [
          {
            id: 'OT32',
            code: 'ADTK',
            airlineCode: '1A',
            statusCode: ' ',
            freetext: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
          }
        ]
      }
    ]
  }
};

export const createAsynchronousJobForAlternativeOfferConfirmationError = {
  errors: [{
    code: '65211',
    title: 'FUNCTIONALITY NOT ENABLED'
  }]
};

export const getAlternativeOfferConfirmationJobCompleted = {
  data: {
    id: 'AY12138213',
    status: 'completed',
    reacceptanceStatus: 'completed'
  }
};

export const getAlternativeOfferConfirmationJobError = {
  errors: [{
    code: '65019',
    title: 'UNABLE TO PROCESS'
  }]
};

export const createAlternativeOfferConfirmationJobPendingCheckin = {
  data: {
    id: 'AF57516314',
    status: 'inProgress'
  }
};

export const getAlternativeOfferConfirmationJobPendingCheckinStarted = {
  data: {
    id: 'AF57516314',
    status: 'inProgress',
    reacceptanceStatus: 'inProgress'
  }
};

export const getAlternativeOffersMockDisruptedOutboundForLostServices = {
  data: [
    {
      type: 'alternative-offers',
      id: '2QUZfAQuc5UOu4Z',
      expiryDateTime: new utils.DateTime(todayPlusNdays('16:35', 15)),
      air: {
        bound: {
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          duration: 45_000,
          flights: [
            {
              id: 'FLT1',
              bookingClass: 'J',
              cabin: 'business'
            },
            {
              id: 'FLT2',
              bookingClass: 'J',
              cabin: 'business'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '2QUZfARuc5U-CMV',
      expiryDateTime: new utils.DateTime(todayPlusNdays('16:35', 15)),
      air: {
        bound: {
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          duration: 49_200,
          flights: [
            {
              id: 'FLT1',
              bookingClass: 'J',
              cabin: 'business'
            },
            {
              id: 'FLT3',
              bookingClass: 'J',
              cabin: 'business'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '2QUZfASuc5U2And',
      expiryDateTime: new utils.DateTime(todayPlusNdays('16:35', 15)),
      air: {
        bound: {
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          duration: 47_400,
          flights: [
            {
              id: 'FLT1',
              bookingClass: 'J',
              cabin: 'business'
            },
            {
              id: 'FLT4',
              bookingClass: 'J',
              cabin: 'business'
            },
            {
              id: 'FLT5',
              bookingClass: 'J',
              cabin: 'business'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '2QUZfATuc5UrZQL',
      expiryDateTime: new utils.DateTime(todayPlusNdays('16:35', 15)),
      air: {
        bound: {
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          duration: 46_200,
          flights: [
            {
              id: 'FLT6',
              bookingClass: 'J',
              cabin: 'business'
            },
            {
              id: 'FLT5',
              bookingClass: 'J',
              cabin: 'business'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '2QUZfAUuc5U_Hes',
      expiryDateTime: new utils.DateTime(todayPlusNdays('16:35', 15)),
      air: {
        bound: {
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          duration: 44_700,
          flights: [
            {
              id: 'FLT7',
              bookingClass: 'J',
              cabin: 'business'
            },
            {
              id: 'FLT8',
              bookingClass: 'J',
              cabin: 'business'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '2QUZfAVuc5UYkUQ',
      expiryDateTime: new utils.DateTime(todayPlusNdays('16:35', 15)),
      air: {
        bound: {
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          duration: 49_200,
          flights: [
            {
              id: 'FLT7',
              bookingClass: 'J',
              cabin: 'business'
            },
            {
              id: 'FLT9',
              bookingClass: 'J',
              cabin: 'business'
            }
          ]
        }
      }
    }
  ],
  dictionaries: {
    airline: {
      AF: 'AIR FRANCE',
      DL: 'DELTA AIR LINES',
      KL: 'KLM ROYAL DUTCH AIRLINES'
    },
    location: {
      AMS: {
        type: 'airport',
        airportName: 'SCHIPHOL AIRPORT',
        cityCode: 'AMS',
        cityName: 'AMSTERDAM',
        countryCode: 'NL'
      },
      CDG: {
        type: 'airport',
        airportName: 'CHARLES DE GAULLE',
        cityCode: 'PAR',
        countryCode: 'FR'
      },
      JFK: {
        type: 'airport',
        airportName: 'JOHN F KENNEDY INTL',
        cityCode: 'NYC',
        countryCode: 'US'
      },
      NCE: {
        type: 'airport',
        airportName: 'COTE D AZUR',
        cityCode: 'NCE',
        cityName: 'NICE',
        countryCode: 'FR'
      },
      ORY: {
        type: 'airport',
        airportName: 'ORLY',
        cityCode: 'PAR',
        countryCode: 'FR'
      },
      NYC: {
        type: 'city',
        cityCode: 'NYC',
        cityName: 'NEW YORK',
        countryCode: 'US'
      },
      PAR: {
        type: 'city',
        cityCode: 'PAR',
        cityName: 'PARIS',
        countryCode: 'FR'
      }
    },
    flight: {
      FLT1: FLIGHT1,
      FLT2: FLIGHT2,
      FLT3: FLIGHT3,
      FLT4: FLIGHT4,
      FLT5: FLIGHT5,
      FLT6: FLIGHT6,
      FLT7: FLIGHT7,
      FLT8: FLIGHT8,
      FLT9: FLIGHT9,
      FLT10: FLIGHT10
    },
    aircraft: {
      319: 'AIRBUS A319',
      320: 'AIRBUS A320',
      321: 'AIRBUS A321',
      332: 'AIRBUS A330-200',
      333: 'AIRBUS A330-300',
      339: 'AIRBUS A330-900NEO',
      764: 'BOEING 767-400',
      772: 'BOEING 777-200/200ER',
      789: 'BOEING 787-9',
      '73H': 'BOEING 737-800 (WINGLETS)',
      '73W': 'BOEING 737-700 (WINGLETS)',
      '77W': 'BOEING 777-300ER',
      E90: 'EMBRAER 190'
    }
  }
};

export const asyncAlternativeOfferConfirmationJobInProgressFor0E: AlternativeOfferConfirmationJob = {
  id: '0E2356656',
  status: 'inProgress',
  rebookingStatus: 'inProgress'
};

export const asyncAlternativeOfferConfirmationJobCompletedFor0E: AlternativeOfferConfirmationJob = {
  id: '0E2356656',
  status: 'completed',
  rebookingStatus: 'completed',
  reacceptanceStatus: 'completed',
  reissuanceStatus: 'completed'
};

export const alternativeOfferForUnOnly = [
  alternativeOfferForUnOnly1,
  alternativeOfferForUnOnly2,
  alternativeOfferForUnOnly3,
  alternativeOfferForUnOnly4,
  alternativeOfferForUnOnly5
];

export const alternativeOffersHelTku = [
  alternativeOfferHelTku1,
  alternativeOfferHelTku2,
  alternativeOfferHelTku3
];

export const getAlternativeOffersMockDisruptedInbound = [
  inboundAlternativeOfferHelTku1,
  inboundAlternativeOfferHelTku2,
  inboundAlternativeOfferHelTku3,
  inboundAlternativeOfferHelTku4,
  inboundAlternativeOfferHelTku5,
  inboundAlternativeOfferHelTku6,
  inboundAlternativeOfferHelTku7,
  inboundAlternativeOfferHelTku8,
  inboundAlternativeOfferHelTku9,
  inboundAlternativeOfferHelTku10,
  inboundAlternativeOfferHelTku11,
  inboundAlternativeOfferHelTku12,
  inboundAlternativeOfferHelTku13,
  inboundAlternativeOfferHelTku14,
  inboundAlternativeOfferHelTku15,
  inboundAlternativeOfferHelTku16,
  inboundAlternativeOfferHelTku17,
  inboundAlternativeOfferHelTku18,
  inboundAlternativeOfferHelTku19,
  inboundAlternativeOfferHelTku20
];

export const alternativeOffersTkuHel = [
  alternativeOfferTkuHel1,
  alternativeOfferTkuHel2,
  alternativeOfferTkuHel3
];

export const alternativeOffersCphOsl = [
  alternativeOfferCphOsl1,
  alternativeOfferCphOsl2
];

export const alternativeOffersOslLhr = [
  alternativeOfferOslLhr1,
  alternativeOfferOslLhr2
];

export const alternativeOffersOslCph = [
  alternativeOfferOslCph1,
  alternativeOfferOslCph2
];
